import { render, staticRenderFns } from "./ContentTypesTable.vue?vue&type=template&id=fca379ac&"
import script from "./ContentTypesTable.vue?vue&type=script&lang=ts&"
export * from "./ContentTypesTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports